import { frontendURL } from '../../../helper/URLHelper';
import MayaraCommercial from './pages/MayaraCommercial.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'contact_manage'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/commercial'),
    name: 'mayara_commercial',
    component: MayaraCommercial,
    meta: commonMeta,
  },
];
